import { cardBorder } from '@monorepo/shared/styles/card';
import styled from 'styled-components';

export const StyledH3 = styled.h3`
  margin-top: 0;
`;

export const StyledDescription = styled.div`
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.colors.gray666};
`;

export const StyledConditionsContainer = styled.div`
  ${cardBorder}
  max-width: 45rem;
  padding: 1.5rem 0.5rem 0 1rem;
  background: ${({ theme }) => theme.colors.grayf4};
`;
